import type { SupabaseClient } from '@supabase/supabase-js'
import type { SendOtpWithEmailRedirect } from '@/modules/auth/use-cases'
import { classifySendOtpRefusal } from './classify-send-otp-refusal'

export class SupabaseSendOtpWithEmailRedirectRepository {
  constructor(private readonly client: SupabaseClient) {}

  execute: SendOtpWithEmailRedirect = async ({ email, emailRedirectTo }) => {
    const { error } = await this.client.auth.signInWithOtp({
      email,
      options: { emailRedirectTo, shouldCreateUser: true },
    })
    if (error) {
      const refusal = classifySendOtpRefusal(error, 'email')
      if (refusal) {
        throw refusal
      }
      throw error
    }
  }
}
